export default __webpack_public_path__ + "static/media/Dining.c60a3523.webp";